const MINDBODY_CODE_MESSAGES: Record<string, string> = {
  InvalidCardType: "Ce type de carte n'est pas accepté.",
  NotSupported: "Ce moyen de paiement n'est pas supporté.",
  InvalidParameter: 'Une des informations saisies est invalide.',
  InvalidCardNumber: 'Le numéro de carte est invalide.',
  InvalidExpiration: "La date d'expiration est invalide.",
  InvalidCVV: 'Le cryptogramme (CVV) est invalide.',
  InvalidBillingName: 'Le nom du titulaire est invalide.',
  Expired: 'Cette carte est expirée.',
  Declined: 'Carte refusée par votre banque.',
  InsufficientFunds: 'Fonds insuffisants sur cette carte.',
  DuplicateTransaction: 'Cette opération a déjà été effectuée.',
  CardLimitExceeded: 'Le plafond de votre carte a été atteint.',
  AuthenticationRequired: "Une authentification 3-D Secure est requise par votre banque.",
};

const FALLBACK_MESSAGE =
  'Nous n’avons pas pu traiter votre carte. Vérifiez le numéro, la date d’expiration et le cryptogramme, puis réessayez.';

export function parseMindbodyError(rawMessage: string | undefined | null): string {
  if (!rawMessage) return FALLBACK_MESSAGE;

  const codes = Array.from(rawMessage.matchAll(/Code:\s*(\w+)/g), (m) => m[1]);

  for (const code of codes) {
    if (MINDBODY_CODE_MESSAGES[code]) return MINDBODY_CODE_MESSAGES[code];
  }

  if (codes.length === 0 && rawMessage.trim() && !rawMessage.includes('Level: Error')) {
    return rawMessage;
  }

  return FALLBACK_MESSAGE;
}
